import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import Schedule from "./schedule";
import { PreLoader } from "../components/preloader";

import { ScheduleEndpointResponseObject } from "../types/presentation";
import UserContext from "../contexts/user";
import WatchSchedule from "./watch-schedule";

const WatchVideo: React.FC<{
  locale: string;
  setLocale: any;
}> = ({ locale, setLocale }) => {
  const { event_slug, presentation_id, version_id } = useParams<{
    event_slug: string;
    presentation_id: string;
    version_id: string;
  }>();

   console.log("event_slug", event_slug);
  // const intl = useIntl();
  const queryClient = useQueryClient();
  const [fetchData, setFetchData] = useState(false);
  // const slug = new URLSearchParams(document.location.search).get('event') || "invalid";
  const [eventPassword] = useLocalStorage(event_slug, "");

  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
      const url =
        process.env.REACT_APP_API_ENDPOINT +
        "/api/public/schedule/" +
        event_slug;
       console.log("url in watch video ", url);

      const response = await axios.get<ScheduleEndpointResponseObject>(url, {
        params: { password: eventPassword },
      });
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {
        const { event } = resp.data;
        resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );

  useEffect(() => {
    //  console.log('debug: ', data, presentation_id);
    if (!data) {
      //  console.log('debug: fetchData')
      setFetchData(true);
    }
  }, [setFetchData, data]);

   console.log("isLoading", isLoading);
  // if (isLoading) return <i>home.tsx: isLoading</i>
  if (isLoading) return <PreLoader />;

  if (error || !data)
    return (
      <div className="login-landing">
        <div className="login-container">
          <div className="login">
            <h4>
              <FormattedMessage id="error.retry.message" />
            </h4>
          </div>
        </div>
      </div>
    );

  const { data: eventData } = data;
  return (
    <div className="home-container-with-login new-schedule-container">
      <WatchSchedule
        locale={locale}
        setLocale={setLocale}
        isSpeaker={true}
        eventData={eventData}
      />
    </div>
  );
};

export default WatchVideo;
